<template>
  <LoaderFullPage v-if="(!user || !isTopbarReady) && isTokenValid" />
  <template v-else>
    <BandeauHorsLigne />
    <RouterView />
  </template>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { useAuthStore } from "@follaw-fr/stores/auth";
import { useUserStore } from "@follaw-fr/stores/user";
import { useUserSettingsStore } from "@follaw-fr/stores/user-settings";
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import BandeauHorsLigne from "@follaw-fr/components/reusable/minerve/BandeauHorsLigne.vue";

const { isTokenValid } = storeToRefs(useAuthStore());
const { isTopbarReady } = storeToRefs(useUserStore());
const { user } = storeToRefs(useUserSettingsStore());
</script>
